import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import * as Styled from './styles';
import PrizeDraw from './PrizeDraw';
import Trophy from './Trophy';
import { useFeatures } from '../../hooks/useFeatures';

const PrizeDrawCard = ({
    eventName,
    TermsLink,
    xLink,
    hadEntry,
    didEntryWin,
    prize
}) => {
    const inPrizeDraw = hadEntry && didEntryWin;
    const { features } = useFeatures();
    const isGoldCup = get(features, 'is_gold_cup', false);
    const winnerAnnouncement = isGoldCup ? (
        'via internal comms.'
    ) : (
        <>
            on our{' '}
            <Styled.XLink target="_blank" href={xLink} rel="noreferrer">
                @ITV7Racing X
            </Styled.XLink>{' '}
            page.
        </>
    );

    return (
        <Styled.PrizeDrawCardContainer>
            {inPrizeDraw && <Trophy />}
            <Styled.PrizeDrawCardBox inPrizeDraw={inPrizeDraw}>
                {hadEntry && (
                    <PrizeDraw
                        raceName={eventName}
                        didEntryWin={didEntryWin}
                        prize={prize}
                    />
                )}
                <Styled.Heading>What happens next?</Styled.Heading>
                <Styled.TextWithSmallerMargin>
                    We&#39;ll announce the lucky{' '}
                    <Styled.Highlighted>Prize Draw winner</Styled.Highlighted>{' '}
                    {winnerAnnouncement}
                </Styled.TextWithSmallerMargin>
                <TermsLink>
                    <Styled.TermsLink>
                        18+ and UK only, T&Cs apply, see here.
                    </Styled.TermsLink>
                </TermsLink>
            </Styled.PrizeDrawCardBox>
        </Styled.PrizeDrawCardContainer>
    );
};

PrizeDrawCard.propTypes = {
    eventName: PropTypes.string.isRequired,
    TermsLink: PropTypes.func.isRequired,
    xLink: PropTypes.string.isRequired,
    hadEntry: PropTypes.bool.isRequired,
    didEntryWin: PropTypes.bool.isRequired,
    prize: PropTypes.string.isRequired
};

export default PrizeDrawCard;
